import React from 'react';

export const GlobalSearchContext = React.createContext();